import * as yup from "yup";

export const logoSchema = yup.object().shape({
 
  logoTitle: yup.string().required("Title is required").trim(),
  logoImage: yup.mixed().required("Logo is required"),

  });

